import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { resetPendingFitMap } from '@/map'
import { useAppDispatch } from '@/store'
import { selectRegionMapStyles, updateMapStyle } from '@/features/domain/ui'
import { selectTerritoryId } from '@/features/domain/territory'

export function useEnsureRegionVisibility() {
  const dispatch = useAppDispatch()

  const territoryId = useSelector(selectTerritoryId)

  // ATTENTION: this REF is intentionally created and not updated
  const rOriginalMapStyle = useRef(useSelector(selectRegionMapStyles))

  useEffect(() => {
    // access previously active region Map Styles
    const originalMapStyle = rOriginalMapStyle.current

    // make region style visible
    dispatch(
      updateMapStyle({
        type: 'region',
        mode: 'on',
      }),
    )

    return () => {
      resetPendingFitMap()

      // restore previously active region Map Styles
      dispatch(
        updateMapStyle({
          type: 'region',
          mode: originalMapStyle.mode,
        }),
      )
    }
  }, [dispatch, territoryId])
}
